/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from 'jsonwebtoken'
import axios from "@/axios.js"
import router from '@/router'

export default {
    login({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/authentications", { id: payload.userDetails.id, password: payload.userDetails.password })
                .then((response) => {

                    if (response.status == '200') {
                        window.sessionStorage.setItem('Ella-Auth-Token', response.headers['ella-auth-token'])
                        const userData = {
                                userId: jwt.decode(response.headers['ella-auth-token']).sub,
                                userRole: jwt.decode(response.headers['ella-auth-token']).jti
                            }
                            // Update user details
                        commit('UPDATE_USER_INFO', userData, { root: true })

                        if (response.data.resultCode === 301 && response.data.resultMessage === "ACCOUNT_RESETED") {
                            router.push({ name: "page-change-password", params: { "isAccountReseted": "true" } })
                        } else if (response.data.resultCode === 302 && response.data.resultMessage === "NEED_PASSWORD_CHANGE") {
                            router.push({ name: "page-change-password", params: { "isNeedPasswordChange": "true" } })
                        } else {
                            
                            if (userData.userRole == "admin" || userData.userRole == "user") {
                                router.push('/dashboard')
                            } else {
                                router.push('/pages/login')
                            }
                        }
                        resolve(response)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    verifyJWT() {
        return new Promise((resolve, reject) => {
            axios.get("/api/verify-token", { params: { accessToken: window.sessionStorage.getItem('Ella-Auth-Token') } })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
}